import { Component, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageBase } from 't4core';



@Component({
    selector: 'InsuranceCasesComponent',
    templateUrl: './InsuranceCasesComponent.html',
    styleUrls: ['./InsuranceCasesComponent.css']
})
export class InsuranceCasesComponent extends PageBase {
    constructor(private router: Router, private route: ActivatedRoute, el: ElementRef) {
        super(el, "FleetManagement");


    }
}
